import React, { useCallback, useEffect } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { APIRoutes, PageRoutes } from "../../Utils/constant";
import HttpService from "../../Hooks/Https-services";
import { getCurrentAuth, getUserData, setAuth } from "../../Hooks/http-server";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
const TenantSelector = () => {
  const userDetails = getUserData();
  const [selectedTenant, setSelectedTenant] = React.useState(
    userDetails?.current_tenant_id
  );
  const [tenants, setTenants] = React.useState<{ id: string; name: string }[]>(
    []
  );
  const auth = getCurrentAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const handleSwitchTenant = async (event: { target: { value: string } }) => {
    const newTenant = event.target.value;
    try {
      setLoading(true);
      const res = await HttpService.postAuth(APIRoutes.SwitchTenant, {
        tenantId: newTenant,
      });
      setAuth({ ...auth, AccessToken: res.data.accessToken });
      navigate(PageRoutes.Home);
      setSelectedTenant(newTenant);
      toast.success("Tenant Switched Successfully");
      window.location.reload();
    } catch (error) {
      console.error(error);
      toast.error("Failed to switch tenant");
    } finally {
      setLoading(false);
    }
  };
  const getTenant = useCallback(async () => {
    try {
      const res = await HttpService.getAuth(APIRoutes.GetTenant);
      const data = res.data?.tenants?.map(
        (tenant: { id: string; name: string }) => ({
          id: tenant.id,
          name: tenant.name,
        })
      );
      setTenants(data || []);
    } catch (error) {
      console.error(error);
    }
  }, []);
  useEffect(() => {
    getTenant();
  }, [getTenant]);
  if (loading) return <CircularProgress />;
  return (
    <FormControl size="small" sx={{ minWidth: 120, mr: 2 }}>
      <InputLabel>Tenant</InputLabel>
      <Select
        value={selectedTenant}
        label="Tenant"
        onChange={handleSwitchTenant}
        disabled={loading}
      >
        {tenants.map((tenant: { id: string; name: string }) => (
          <MenuItem
            sx={{ textTransform: "capitalize" }}
            key={tenant.id}
            value={tenant.id}
          >
            {tenant.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TenantSelector;
